"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      back1: false,
      adminDia: false,
      funBtns: [{
        size: "small",
        click: "add",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }, {
        size: "small",
        click: "del",
        icon: "el-icon-circle-close",
        name: "批量删除",
        type: "danger"
      }],
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "管理员姓名"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "管理员姓名",
        prop: "userName",
        isShow: true,
        width: "200"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "200"
      },
      // {
      //   name: "所属学校",
      //   prop: "matchTypeName",
      //   isShow: true,
      //   width: "200"
      // },
      {
        name: "邮箱",
        prop: "email",
        isShow: true,
        width: "200"
      }, {
        name: "电话",
        prop: "phone",
        isShow: true,
        width: "200"
      }, {
        name: "创建时间",
        prop: "createTime",
        // isShow: true,
        width: "300",
        sortable: true
      }],
      defaultColumn2: [{
        name: "管理员姓名",
        prop: "name",
        isShow: true,
        width: "200"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "200"
      }, {
        name: "邮箱",
        prop: "mail",
        isShow: true,
        width: "200"
      }, {
        name: "电话",
        prop: "phoneNumber",
        isShow: true,
        width: "200"
      }, {
        name: "创建时间",
        prop: "createTime",
        width: "300",
        sortable: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      page2: {
        pageNumber: 1,
        pageSize: 5
      },
      totalData: 0,
      totalData2: 0,
      listData: [],
      listData2: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      searchName: "",
      options: [{
        name: "删除",
        class: "editor",
        option: "del",
        span: 5
      }]
    };
  },
  methods: {
    // 新增按钮
    add: function add() {
      this.adminDia = true;
      this.getProAdmin();
    },
    delDia: function delDia() {
      this.adminDia = false;
    },
    // 添加管理员到项目下
    saveAdmin: function saveAdmin() {
      var _this = this;
      (0, _project.payForAdmin)({
        matchId: this.$route.query.id,
        userId: this.checkBoxs
      }).then(function (res) {
        _this.$message.success("操作成功。");
        _this.adminDia = false;
        _this.getAdminList();
      });
    },
    // 模糊搜索
    search: function search(v) {
      this.searchName = v.queryValue;
    },
    //获取项目下管理员列表
    getAdminList: function getAdminList() {
      var _this2 = this;
      (0, _project.getObjectAdminList)({
        id: this.$route.query.id,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    //获取省份下项目管理员列表
    getProAdmin: function getProAdmin() {
      var _this3 = this;
      (0, _project.findObjectAdminList)({
        pageSize: this.page2.pageSize,
        pageNum: this.page2.pageNumber
      }).then(function (res) {
        var data = res.data;
        _this3.listData2 = data.list;
        _this3.totalData2 = data.total;
      });
    },
    // 编辑
    reset: function reset(row) {
      var _this4 = this;
      this.$confirm("确认重置吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.resetPass)({
          id: row.id
        }).then(function () {
          _this4.getAdminList();
          _this4.$message.success("操作成功。");
        });
      }).catch(function () {
        _this4.$message.info("取消重置。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this5 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this5.checkBoxs.push(item.id);
      });
    },
    //
    handleSelectionChange2: function handleSelectionChange2(e) {
      var _this6 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this6.checkBoxs.push(item.id);
      });
    },
    // 删除管理员
    del: function del(row) {
      var _this7 = this;
      var idList = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        idList.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        idList = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.removeAdmin)({
          idList: idList
        }).then(function () {
          _this7.getAdminList();
          _this7.$message.success("操作成功。");
        });
      }).catch(function () {
        _this7.$message.info("取消删除。");
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getAdminList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getAdminList();
    },
    handleCurrentChange2: function handleCurrentChange2(e) {
      this.page2.pageNumber = e;
      this.getProAdmin();
    },
    handleSizeChange2: function handleSizeChange2(e) {
      this.page2.pageSize = e;
      this.page2.pageNumber = 1;
      this.getProAdmin();
    }
  },
  created: function created() {
    this.getAdminList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};